/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const DiscountSettingPage = lazyLoad(
  () => import('./index'),
  module => module.DiscountSettingPage
);
